export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5112.d3e88d5f.jpg";